import { gameInfoType } from '@op/types/common';
import React from 'react';
import MobileStore from './MobileStore';
import Steam from './Steam';

export default function GameStore({
  gameInfo,
  ...props
}: {
  gameInfo: gameInfoType;
  filter: any;
  gameData: any;
  wholeGameInfo: any;
  [key: string]: any;
}) {
  if (gameInfo?.entity_type === 'mobile') {
    return <MobileStore {...props}></MobileStore>;
  }

  if (gameInfo.entity_type === 'console') {
    return null;
  }

  return <Steam {...props}></Steam>;
}
